export type OfferStatus =
  | 'draft' | 'sent' | 'requested' | 'accepted' | 'declined' | 'rejected' | 'withdrawn';

export type OfferService = { id?: string; text: string; sort_order?: number };

export type OfferHourlyRate = {
  id?: string;
  label: string;
  hourly_rate: string;
  sort_order?: number;
};

export type OfferPackage = {
  id?: string;
  name: string;
  summary: string;
  monthly_fee: string;
  sort_order?: number;
  services: OfferService[];
  hourly_rates: OfferHourlyRate[];
};

export type Offer = {
  id: string;
  client: string;
  company_name?: string;
  title: string;
  introduction: string;
  currency: string;
  status: OfferStatus;
  status_display: string;
  billing_mode: 'direct' | 'via_aoc';
  valid_until: string | null;
  packages: OfferPackage[];
  is_public: boolean;
  source_offer: string | null;
  sent_at: string | null;
  requested_at: string | null;
  accepted_at: string | null;
  declined_at: string | null;
  rejected_at: string | null;
  ended_at: string | null;
  accepted_package: string | null;
  accepted_by_email: string;
  decline_reason: string;
  rejection_reason: string;
  monthly_fee: string | null;
  is_running: boolean;
  created_at: string;
  updated_at: string;
};

export const CURRENCIES = ['EUR', 'USD', 'CZK', 'GBP', 'PLN'];

// What someone may actually ask for, as opposed to what they have.
//
// money rounds to whole units, so a balance of 1322.60 reads as 1,323 -- and
// an advisor who asks for the figure the page just showed them is refused for
// asking for more than they have, with nothing on screen saying why. Rounding
// a limit down keeps the number shown obtainable.
export function moneyAvailable(amount: string | number | null, currency: string) {
  const value = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (value == null || Number.isNaN(value)) return money(amount, currency);
  return money(Math.floor(value), currency);
}

export function money(amount: string | number | null, currency: string) {
  const value = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (value == null || Number.isNaN(value)) return '—';
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency', currency, maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `${value.toLocaleString()} ${currency}`;
  }
}
